import Attack from "./Attacks";

class DroneAttack extends Attack {
	/**
	 * 
	 * @param {number} startTimestamp
	 */
    constructor(startTimestamp) {
		super(startTimestamp);

		// This line must be at the end
		this.init();
	}

	init() {
		// This line must be at the top
		super.init();
	}

	update() {
		// Operations to update during the attack
	}

	end(endTimestamp) {
		// This must be the first line
		super.end(endTimestamp);
	}
}

export default DroneAttack;
